import { cn } from "@/lib/utils";

interface StepIndicatorProps {
  currentStep: number;
  onStepClick: (step: number) => void;
}

export function StepIndicator({
  currentStep,
  onStepClick,
}: StepIndicatorProps) {
  const steps = [
    { number: 1, label: "Typ" },
    { number: 2, label: "Eckdaten" },
    { number: 3, label: "Zugriffe" },
  ];

  return (
    <div className="flex items-center justify-center mb-8 space-x-2">
      {steps.map((step, index) => (
        <div key={step.number} className="flex items-center">
          <div
            className={cn(
              "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium cursor-pointer",
              currentStep === step.number
                ? "bg-primary text-primary-foreground"
                : "bg-muted text-muted-foreground hover:bg-primary/80 hover:text-primary-foreground",
            )}
            onClick={() => onStepClick(step.number)}
            role="button"
          >
            {step.number}
          </div>
          {index < steps.length - 1 && (
            <div
              className={cn(
                "w-12 h-1 mx-2",
                step.number < currentStep ? "bg-primary" : "bg-muted",
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
}
